import {Component, Input, OnInit} from '@angular/core';
import {ModalController} from "@ionic/angular";

@Component({
  selector: 'app-openable-modal-toolbar-empty',
  templateUrl: './openable-modal-toolbar-empty.component.html',
  styleUrls: ['./openable-modal-toolbar-empty.component.scss'],
})
export class OpenableModalToolbarEmptyComponent implements OnInit {

  @Input() title:string;
  constructor(private modalController: ModalController) { }

  ngOnInit() {}

  dismiss(){
    this.modalController.dismiss();
  }
}
